import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSystemBannerStore = defineStore('systemBanner', () => {
  const banners = ref([])

  function addBanner({ id, type = 'info', messageEn, messageDe, dismissable = true }) {
    if (banners.value.some(b => b.id === id)) return
    banners.value.push({ id, type, messageEn, messageDe, dismissable })
  }

  function removeBanner(id) {
    banners.value = banners.value.filter(b => b.id !== id)
  }

  function clearAll() {
    banners.value = []
  }

  /**
   * Lädt System-Banner vom API-Endpunkt.
   * Schlägt der Endpoint fehl, werden keine Banner gezeigt (silent fail).
   */
  async function fetchBanners(api) {
    try {
      const { data } = await api.get('/system/banners')
      const items = Array.isArray(data) ? data : (data?.items ?? [])
      items.forEach(b => addBanner(b))
    } catch {
      // Endpoint existiert noch nicht → kein Banner
    }
  }

  return { banners, addBanner, removeBanner, clearAll, fetchBanners }
})
